import React from "react";
import { Route, Routes } from "react-router-dom";
import MainComponent from "./MainComponent";
import ProductAndServices from "../Pages";

const RouteComponent = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<MainComponent />}>
        <Route index element={<ProductAndServices/>}/>
        </Route>
      </Routes>
    </div>
  );
};

export default RouteComponent;
